import { useContext } from 'react';

import { WhiteboardContext, IWhiteboardContext } from 'context';

export function useWhiteboard(): IWhiteboardContext {
  return useContext(WhiteboardContext)!;
}
